import React from 'react';
import styles from './Banner.module.scss';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { formatTime, getMatchDescription } from '../../../utils/render';
import Periods from './Periods/Periods';
import { LANGUAGES } from '../../../constants/defaultValues';
import BookedBadge from '../../shared/BookedBadge/BookedBadge';

const Banner = ({ event }) => {
    const locale = useSelector(state => state.settings.locale);

    const { liveStatistics } = event;

    let {
        homeTeamScore,
        awayTeamScore,
        homeTeamCurrentPeriodScore,
        awayTeamCurrentPeriodScore,
        eventTime,
        remainingTimeInPeriod,
        stoppageTime,
    } = liveStatistics || {};

    const formattedEventTime = formatTime(eventTime);
    const formattedRemainingTime = formatTime(remainingTimeInPeriod);
    const formattedStoppageTime = formatTime(stoppageTime);

    const hasEventStarted =
        liveStatistics &&
        Object.keys(liveStatistics).length &&
        liveStatistics.matchStatusCode &&
        liveStatistics.matchStatusCode !== 0;

    return (
        <div className={'relative'}>
            {event.liveStatistics?.matchStatusCode > 0 && (
                <Periods liveStatistics={event.liveStatistics} />
            )}
            <div className={styles.banner}>{/*<img src={stadium} alt='Time' />*/}</div>
            <div className={styles.event}>
                <div className={styles.competitorName}>
                    <span className={styles.name}>
                        {event.teams?.home?.[locale] || event.teams?.home?.[LANGUAGES.eng]}
                    </span>
                    <span className={styles.score}>{homeTeamScore}</span>
                </div>
                <div className={styles.eventInfo}>
                    <div className={styles.bookedBadgeContainer}>
                        <BookedBadge isBooked={event.booked} isLive={event.live} />
                    </div>
                    <span className={styles.id}>{event.programCode}</span>
                    {hasEventStarted && (formattedEventTime || formattedRemainingTime) ? (
                        <div className={styles.liveStatistics}>
                            <span className={'m-r-2'}>
                                {formattedRemainingTime || formattedEventTime}
                            </span>
                            {formattedStoppageTime ? (
                                <span className={styles.stoppageTime}>
                                    +{formattedStoppageTime}
                                </span>
                            ) : null}
                        </div>
                    ) : null}
                    {hasEventStarted ? (
                        <>
                            <div className={styles.status}>
                                <span>
                                    {getMatchDescription(liveStatistics.matchStatusCode, {
                                        locale,
                                    })}
                                </span>
                                <span>-</span>
                                <span>{homeTeamCurrentPeriodScore}</span>
                                <span>:</span>
                                <span>{awayTeamCurrentPeriodScore}</span>
                            </div>
                        </>
                    ) : (
                        <span className={styles.date}>
                            <span className={'m-r-2'}>
                                {moment.unix(event.startedAt).format('DD MMMM HH:mm')}
                            </span>
                        </span>
                    )}
                </div>
                <div className={styles.competitorName}>
                    <span className={styles.name}>
                        {event.teams?.away?.[locale] || event.teams?.away?.[LANGUAGES.eng]}
                    </span>
                    <span className={styles.score}>{awayTeamScore}</span>
                </div>
            </div>
        </div>
    );
};

export default Banner;
